module.exports = __webpack_public_path__ + "img/28-image-1@2x.1169a983.png";